(function (window, angular, undefined) {
    angular.module('formApp')
        .directive("compareTo", [function () {
            return {
                require: "ngModel",
                link: function(scope, element, attrs, model) {
                    model.$validators.compareTo = function(val) {
                        model.$setValidity('breedmatch', val !== scope.$eval(attrs.compareTo));
                        return val !== scope.$eval(attrs.compareTo);
                    };
                    scope.$watch(attrs.compareTo, function() {
                        model.$validate();
                    });
                }
            };
        }]);
})(window, window.angular);